/**
 * Dynamically adjusts the number of circles in dots-divider based on container width
 */
function updateDotsDivider() {
  const dividers = document.querySelectorAll<HTMLDivElement>(".dots-divider");

  dividers.forEach((divider) => {
    const width = divider.offsetWidth;
    const circleSpacing = 230; // pixels between SVG elements

    const numCircles = Math.max(3, Math.floor(width / circleSpacing));

    // Clear existing SVG elements
    divider.innerHTML = "";

    // Create individual SVG elements with one circle each
    for (let i = 0; i < numCircles; i++) {
      const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.setAttribute("width", "10");
      svg.setAttribute("height", "10");

      const circle = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "circle",
      );
      circle.setAttribute("cx", "5");
      circle.setAttribute("cy", "5");
      circle.setAttribute("r", "5");

      svg.appendChild(circle);
      divider.appendChild(svg);
    }
  });
}

// Update on load
updateDotsDivider();

// Update on resize
let resizeTimeout: number;
window.addEventListener("resize", () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = window.setTimeout(updateDotsDivider, 150);
});
